import React from 'react';
import Seo from '../components/Seo';
import './InfoPages.css';

const RulesPage = () => (
    <div className="info-page">
        <Seo title="Правила" description="Правила использования Dealzy." />
        <h1 className="info-page__title">Правила</h1>
        <p className="info-page__placeholder">Раздел находится в разработке. Правила появятся здесь в ближайшее время.</p>
    </div>
);

export default RulesPage;
